
import _ from "lodash"
import {VIEW_DISPATCHS} from "@/store/contracts" 
import { getView,getViews } from "@/api/indicatrix"
const state= {
    /**
     * [
     *  {topProjectId:xx, projectId:xx, path:xxx, title:xx}
     * ]
     */
    views: {}
}
const mutations={
    setView: function(state, view){
        const viewId = view._id
        state.views[viewId] = view        
    }
}
const actions={
    [VIEW_DISPATCHS.LOAD_VIEW]: async ({ commit, state}, viewId)=>{

        let view = state.views[viewId]
        if(!view){
            view = await getView(viewId)
            commit.setView(view)
        }
        return view

    },
    [VIEW_DISPATCHS.LOAD_VIEWS]: async ({ commit, state}, viewIds)=>{
        if(viewIds && viewIds.length){
            const views ={}
            const notExistIds = []
            for (let i = 0; i < viewIds.length; i++) {
                const viewId = viewIds[i];
                const view = state.views[viewId]
                if(!view){
                    notExistIds.push(viewId)
                }else{
                    views[viewId] = view
                }
            }
            if(notExistIds.length){
                const viewsInDb = await getViews(viewIds).then(r=>r.data)
                
                if(viewsInDb && viewsInDb.length){
                    viewsInDb.forEach(view => {
                        if(view!=null){
                            commit('setView',view)
                            views[view._id] = view
                        }                        
                    });
                }
            }
            return views

        }

    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}